import type { WalletOption } from "../hooks/useWallet";

export function WalletProviderChooser({
  walletOptions,
  selectedWalletId,
  selectWallet
}: {
  walletOptions: WalletOption[];
  selectedWalletId: string | null;
  selectWallet: (id: string) => void;
}) {
  if (walletOptions.length <= 1) return null;

  return (
    <div className="wallet-provider-chooser" aria-label="Wallet provider chooser">
      <div className="text-sm text-muted">Choose wallet provider</div>
      <div className="wallet-provider-chooser__grid">
        {walletOptions.map((wallet) => {
          const active = wallet.id === selectedWalletId;
          return (
            <button
              key={wallet.id}
              type="button"
              className={`wallet-provider-chooser__option${active ? " wallet-provider-chooser__option--active" : ""}`}
              onClick={() => selectWallet(wallet.id)}
              aria-pressed={active}
            >
              {wallet.icon && <img src={wallet.icon} alt="" aria-hidden="true" />}
              <span>{wallet.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
